(function () {
  'use strict';

  function getParam(name) {
    try {
      return new URLSearchParams(window.location.search).get(name) || '';
    } catch (e) {
      return '';
    }
  }

  function formatEntryLabel(prefix, value) {
    var storage = window.HpEntryStorage;
    var digits = storage ? storage.formatEntryDigits(value) : String(value || '');
    if (!digits) return (prefix || 'No.') + ' ' + String(value || '');
    return (prefix || 'No.') + ' ' + digits;
  }

  function parseEntryNumber(value) {
    var storage = window.HpEntryStorage;
    var normalized = storage ? storage.normalizeEntry(value) : String(value || '').replace(/\D/g, '');
    return parseInt(normalized, 10) || 0;
  }

  function HpConfirmation(root, config) {
    this.root = root;
    this.config = config;
    this.entryNo = this.resolveEntry();
    this.email = this.resolveEmail();
    this.cacheDom();
    this.applyDynamicText();
    this.initEntryAnimation();
    this.mountConfetti();
    this.initOwl();
    this.initCounters();
    if (config.confettiBurst !== false) {
      var self = this;
      this._confettiTimer = window.setTimeout(function () {
        self.burst();
      }, 350);
    }
    this.bindEvents();
  }

  HpConfirmation.prototype.resolveEntry = function () {
    var storage = window.HpEntryStorage;
    var fromUrl = getParam('entry') || getParam('entry_no') || getParam('number');
    if (fromUrl) {
      var normalized = storage ? storage.normalizeEntry(fromUrl) : fromUrl.replace(/\D/g, '');
      if (storage && normalized) storage.setEntry(normalized);
      return normalized || fromUrl;
    }
    if (storage) {
      var stored = storage.getEntry();
      if (stored) return stored;
      return storage.assignEntry(false);
    }
    return parseEntryNumber(this.config.entryNumber) || '1249';
  };

  HpConfirmation.prototype.resolveEmail = function () {
    var storage = window.HpEntryStorage;
    var fromUrl = getParam('email');
    if (fromUrl) {
      var decoded = decodeURIComponent(fromUrl);
      if (storage) storage.setEmail(decoded);
      return decoded;
    }
    if (storage) {
      var stored = storage.getEmail();
      if (stored) return stored;
    }
    return this.config.email || 'you@owlpost.com';
  };

  HpConfirmation.prototype.cacheDom = function () {
    this.owlEl = this.root.querySelector('[data-cf-owl]');
    this.confettiEl = this.root.querySelector('[data-cf-confetti]');
    this.quizBtn = this.root.querySelector('[data-cf-quiz-btn]');
    this.entryEls = this.root.querySelectorAll('[data-cf-entry]');
    this.emailEls = this.root.querySelectorAll('[data-cf-email]');
    this.counterEls = this.root.querySelectorAll('[data-cf-counter]');
  };

  HpConfirmation.prototype.mountConfetti = function () {
    if (!this.confettiEl || this.confettiEl.dataset.cfMounted) return;
    document.body.appendChild(this.confettiEl);
    this.confettiEl.dataset.cfMounted = '1';
  };

  HpConfirmation.prototype.applyDynamicText = function () {
    for (var j = 0; j < this.emailEls.length; j++) {
      this.emailEls[j].textContent = this.email;
    }

    var stepTexts = this.root.querySelectorAll('.hp-conf__step-text');
    for (var s = 0; s < stepTexts.length; s++) {
      stepTexts[s].innerHTML = stepTexts[s].innerHTML
        .replace(/\[email\]/g, '<b>' + this.email + '</b>');
    }
  };

  HpConfirmation.prototype.updateStepEntryText = function (entryLabel) {
    var stepTexts = this.root.querySelectorAll('.hp-conf__step-text');
    for (var s = 0; s < stepTexts.length; s++) {
      stepTexts[s].innerHTML = stepTexts[s].innerHTML
        .replace(/\[entry\]/g, '<b>' + entryLabel + '</b>');
    }
  };

  HpConfirmation.prototype.initEntryAnimation = function () {
    var prefix = this.config.entryPrefix || 'No.';
    var storage = window.HpEntryStorage;
    var target = parseEntryNumber(this.entryNo);
    var finalLabel = formatEntryLabel(prefix, target);

    if (!this.entryEls.length || !target) {
      this.updateStepEntryText(finalLabel);
      return;
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      for (var i = 0; i < this.entryEls.length; i++) {
        this.entryEls[i].textContent = finalLabel;
      }
      this.updateStepEntryText(finalLabel);
      return;
    }

    var start = Math.max(1, target - Math.max(180, Math.floor(target * 0.22)));
    var duration = 3200;
    var startedAt = 0;
    var self = this;

    function easeOutCubic(t) {
      return 1 - Math.pow(1 - t, 3);
    }

    function renderFrame(value) {
      var label = prefix + ' ' + (storage ? storage.formatEntryDigits(value) : String(value));
      for (var e = 0; e < self.entryEls.length; e++) {
        self.entryEls[e].textContent = label;
      }
    }

    function tick(timestamp) {
      if (!startedAt) startedAt = timestamp;
      var progress = Math.min(1, (timestamp - startedAt) / duration);
      var current = Math.round(start + (target - start) * easeOutCubic(progress));
      renderFrame(current);

      if (progress < 1) {
        window.requestAnimationFrame(tick);
        return;
      }

      for (var f = 0; f < self.entryEls.length; f++) {
        self.entryEls[f].textContent = finalLabel;
      }
      self.updateStepEntryText(finalLabel);
    }

    renderFrame(start);
    window.requestAnimationFrame(tick);
  };

  HpConfirmation.prototype.initOwl = function () {
    if (!this.owlEl || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    this.owlEl.style.animation = 'cf-owl-in 1s cubic-bezier(.2,.8,.2,1) both';
    var owl = this.owlEl;
    window.setTimeout(function () {
      owl.style.animation = 'cf-bob 4s ease-in-out infinite';
    }, 1100);
  };

  HpConfirmation.prototype.initCounters = function () {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      for (var i = 0; i < this.counterEls.length; i++) {
        var targetStatic = parseInt(this.counterEls[i].getAttribute('data-target'), 10) || 0;
        this.counterEls[i].textContent = targetStatic.toLocaleString();
      }
      return;
    }

    for (var c = 0; c < this.counterEls.length; c++) {
      (function (el) {
        var target = parseInt(el.getAttribute('data-target'), 10) || 0;
        var value = Math.max(0, target - 60);
        var timer = window.setInterval(function () {
          value += Math.ceil((target - value) / 6);
          if (value >= target) {
            value = target;
            window.clearInterval(timer);
          }
          el.textContent = value.toLocaleString();
        }, 60);
      })(this.counterEls[c]);
    }
  };

  HpConfirmation.prototype.burst = function () {
    if (!this.confettiEl || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var cols = ['#CA9E48', '#F9E78D', '#6071CD', '#ffffff', '#7D0000'];
    var shapes = ['✦', '◈', '✉', '⬡', '❡', '♛'];
    var width = this.confettiEl.clientWidth || window.innerWidth;
    var count = window.innerWidth >= 881 ? 90 : 60;

    for (var i = 0; i < count; i++) {
      var piece = document.createElement('div');
      piece.textContent = shapes[Math.floor(Math.random() * shapes.length)];
      piece.style.cssText =
        'position:absolute;top:0;left:' + (Math.random() * width).toFixed(0) + 'px;' +
        'color:' + cols[Math.floor(Math.random() * cols.length)] + ';' +
        'font-size:' + (10 + Math.random() * 16).toFixed(0) + 'px;' +
        'opacity:0;animation:cf-confetti ' + (2.2 + Math.random() * 2.2).toFixed(1) + 's linear ' +
        (Math.random() * 0.7).toFixed(2) + 's forwards;';
      this.confettiEl.appendChild(piece);
      (function (node) {
        window.setTimeout(function () {
          if (node.parentNode) node.parentNode.removeChild(node);
        }, 5600);
      })(piece);
    }
  };

  HpConfirmation.prototype.showToast = function (message) {
    if (!message || document.querySelector('[data-cf-toast]')) return;

    var toast = document.createElement('div');
    toast.className = 'hp-conf__toast';
    toast.setAttribute('data-cf-toast', '');
    toast.textContent = message;
    document.body.appendChild(toast);

    window.requestAnimationFrame(function () {
      toast.classList.add('hp-conf__toast--visible');
    });

    window.setTimeout(function () {
      toast.classList.remove('hp-conf__toast--visible');
      window.setTimeout(function () {
        if (toast.parentNode) toast.parentNode.removeChild(toast);
      }, 400);
    }, 2600);
  };

  HpConfirmation.prototype.bindEvents = function () {
    var self = this;
    if (!this.quizBtn) return;

    this.quizBtn.addEventListener('click', function (e) {
      var url = self.config.quizUrl;
      if (url) return;
      e.preventDefault();
      self.showToast(self.config.toastMessage);
    });
  };

  function parseConfig(scriptEl) {
    if (!scriptEl) return null;
    try {
      return JSON.parse(scriptEl.textContent);
    } catch (e) {
      console.error('HP Confirmation: invalid config JSON', e);
      return null;
    }
  }

  function init() {
    document.querySelectorAll('[data-hp-confirmation]').forEach(function (root) {
      if (root.dataset.cfReady) return;
      var script = root.querySelector('[data-cf-config]');
      var config = parseConfig(script);
      if (!config) return;
      root.dataset.cfReady = '1';
      new HpConfirmation(root, config);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
